import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import TawlaGroups from "./TawlaGroups";
import { useTranslation } from "react-i18next";
const defaultAutos = {
    Branches: [],
};

export default function TawlaCon() {

  const { t } = useTranslation(["forms"]);
  const [branch, setBranch] = useState({ id: -1, name: t("all") });
  const tb = {
    wait: true,
    other: true,
    Branch: true,
    Tawla: true,
    TawlaGroups:true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms:{
      iempid: sto.empi,
      tname: "tawla",
      branch:  branch.id == -1 ? sto.branchi : branch.id 
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch],
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches 
  )
    return <LoadingPage />;

  return (
    <TawlaGroups
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        branch,
        setBranch,
        isGroups:false,
      }}
    />
  );
}
